import "./ModalSettingsOptionCard.scss"

import { SvgIcon } from "@skylead/component-library"
import classNames from "classnames"
import React from "react"

import { useTooltip } from "../../../utils/hook"

const ModalSettingsOptionCard = ({
  icon,
  iconClassName = "master-login-icon primary-color",
  text,
  onClick,
  disabled = false,
  tooltipText,
  tooltipTop,
  tooltipLeft,
  alignItemAbove = false,
}) => {
  const modalSettingsOptionCardClass = classNames("modal-settings-option-card-wrapper", {
    "modal-settings-option-card-disabled": !!disabled,
  })

  const [tooltip, setTooltip, closeTooltip] = useTooltip(10, 0)

  return (
    <div>
      {tooltip}
      <div
        className={modalSettingsOptionCardClass}
        onClick={e => {
          if (!disabled) {
            onClick(e)
          }
        }}
      >
        <div
          className="modal-settings-option-card-body"
          onMouseEnter={e => {
            if (tooltipText) {
              setTooltip({
                event: e,
                text: tooltipText,
                topPos: tooltipTop,
                leftPos: tooltipLeft,
                alignItemAbove,
              })
            }
          }}
          onMouseLeave={closeTooltip}
        >
          <div>
            <SvgIcon
              icon={icon}
              className={iconClassName}
              style={{ margin: 0, marginRight: 10, width: 30, height: 30 }}
            />
            {text}
          </div>
          <SvgIcon
            spanClassName="d-flex"
            icon="arrow-left"
            className="master-login-icon master-login-icon-modal-card"
            style={{ margin: 0, transform: "rotate(180deg)" }}
          />
        </div>
      </div>
    </div>
  )
}

// ModalSettingsOptionCard.propTypes = {
//   disabled: PropTypes.bool,
//   onClick: PropTypes.func.isRequired,
//   text: PropTypes.string.isRequired,
//   iconClassName: PropTypes.string,
//   icon: PropTypes.string.isRequired,
//   tooltipText: PropTypes.string,
//   tooltipTop: PropTypes.number,
//   tooltipLeft: PropTypes.number,
//   alignItemAbove: PropTypes.bool,
// }

export default ModalSettingsOptionCard
